<template>
  <nav :class="`paginator paginator--${pStyle}`">
    <ul v-if="isStyleEfficient" class="pagination" :class="[pSize]">
      <li v-show="pShowTotal && pTotal > 1" class="disabled">
        <a><span>Total {{ pTotal }}</span></a>
      </li>
      <li :class="{disabled: isPageCurrent(firstPage)}" title="First page">
        <a :href="`#${firstPage}`" @click.prevent="openPage(firstPage)">
          <span aria-hidden="true">&Lang;</span>
        </a>
      </li>
      <li :class="{disabled: false === prevPage}" title="Previous page">
        <a :href="`#${prevPage}`" @click.prevent="openPage(prevPage)">
          <span aria-hidden="true">&lang;</span>
        </a>
      </li>
      <li
        :class="{active:isPageCurrent(pageInRange)}"
        v-for="pageInRange in pageRanges"
        :key="pageInRange"
        >
        <a :href="`#${pageInRange}`" @click.prevent="openPage(pageInRange)">{{ pageInRange }}</a>
      </li>
      <li :class="{disabled: false === nextPage}" title="Next page">
        <a :href="`#${nextPage}`" @click.prevent="openPage(nextPage)">
          <span aria-hidden="true">&rang;</span>
        </a>
      </li>
      <li :class="{disabled: isPageCurrent(lastPage)}" title="Last page">
        <a :href="`#${lastPage}`" @click.prevent="openPage(lastPage)">
          <span aria-hidden="true">&Rang;</span>
        </a>
      </li>
      <li v-show="pShowPerPage" class="disabled">
        <span v-if="pEditPerPage">
          <span>Showing </span>
          <span>
            <select @change="changePerPage(parseInt($event.target.value))">
              <option v-for="opt in perPageOptions" :key="opt" :selected="pPerPage == opt" :value="opt">{{ opt }}</option>
            </select>
          </span>
          <span> per page</span>
        </span>
        <a v-else>
          <span>Showing {{ pPerPage }} per page</span>
        </a>
      </li>
    </ul>
    <ul v-if="isStylePreviousNext" class="pager">
      <li class="pager__previous">
        <a v-if="prevPage" :href="`#${prevPage}`" @click.prevent="openPage(prevPage)">Previous</a>
        <span v-else>Previous</span>
      </li>
      <li class="pager__next">
        <a v-if="nextPage" :href="`#${nextPage}`" @click.prevent="openPage(nextPage)">Next</a>
        <span v-else>Next</span>
      </li>
      <li class="pager__details">Page {{ pPage }} of {{ pRangeLength }} (Total of {{ pTotal }})</li>
    </ul>
  </nav>
</template>

<script>
  import _ from 'lodash'

  export default {
    name: 'pagination',
    props: {
      pStyle: {
        type: String,
        default: 'efficient'
      },
      pTotal: {
        type: Number,
        default: 20
      },
      pPerPage: {
        type: Number,
        default: 10
      },
      pPage: {
        type: Number,
        default: 1
      },
      pRangeLength: {
        type: Number,
        default: 10
      },
      pShowTotal: {
        type: Boolean,
        default: false
      },
      pShowPerPage: {
        type: Boolean,
        default: false
      },
      pEditPerPage: {
        type: Boolean,
        default: false
      },
      pSize: {
        type: String,
        default: ''
      }
    },
    computed: {
      isStyleEfficient() {
        return 'efficient' == this.pStyle
      },
      isStylePreviousNext() {
        return 'previous-next' == this.pStyle
      },
      prevPage() {
        let page = this.currentPage - 1
        if (!page || page < 1) {
          page = false
        }
        return page
      },
      nextPage() {
        let page = this.currentPage + 1
        if (!page || page < 1) {
          page = 1
        }
        if (page > this.lastPage) {
          page = false
        }
        return page
      },
      pageRanges() {
        return _.range(this.firstPageInRange, this.lastPageInRange + 1)
      },
      lastPageInRange() {
        let page  = this.firstPageInRange + this.pRangeLength - 1
        if (page > this.lastPage) {
          page = this.lastPage
        }
        return page
      },
      firstPageInRange() {
        const gap = Math.floor(this.pRangeLength / 2)
        let page = this.currentPage - gap
        if (page < 1) {
          page = 1
        }
        if (page !== 1 && page > this.highestFirstPageInRange) {
          page = this.highestFirstPageInRange
        }
        if (page < 1) {
          page = 1
        }
        return page
      },
      highestFirstPageInRange() {
        return this.lastPage - this.pRangeLength + 1
      },
      firstPage() {
        return 1
      },
      lastPage() {
        return Math.ceil(this.pTotal / this.pPerPage)
      },
      currentPage() {
        return this.pPage > 0 ? this.pPage : 1
      },
      perPageOptions() {
        return [5, 10, 15, 20, 50, 100]
      }
    },
    methods: {
      openPage(page) {
        if (!_.isNumber(page)) {
          return
        }
        if (this.isPageCurrent(page)) {
          return
        }

        this.$emit('open-page', page)
      },
      isPageCurrent(page) {
        return page === this.currentPage
      },
      changePerPage(perPage) {
        this.$emit('per-page-change', perPage)
      }
    }
  }
</script>
